import routerOptions0 from "/home/runner/work/subturtle-dashboard-app/subturtle-dashboard-app/frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  linkExactActiveClass: "active",
  hashMode: true,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}